import { inject } from "@angular/core";
import { environment } from "@env/environment";
import { ILieferantenPortalEnvironment } from "FoxxyInterfaces";
import { EnvironmentService, AuthService } from "FoxxyLib";
import { authConfig } from "./oauth.config";

export function intializeApp(): Promise<any> {

  const environmentService  = inject(EnvironmentService<ILieferantenPortalEnvironment>);
  const authService = inject(AuthService);

  return (async () => {
    try {

      const res = await fetch('./assets/config/config.json');
      const configuration = await res.json();
      authConfig.issuer = configuration['AuthIssuer'];
      if (authConfig.issuer == undefined)
      {
        throw new Error('AuthIssuer not defined for SSO');
      }

      //GA** Save original URL path for redirect after OAuth login
      const pathname = window.location.pathname;
      const search = window.location.search;
      const host = window.location.origin;
      //nachfolgende direktiven Pfade sollen als redirect erlaubt werden
      if (pathname.includes('/sortimentieren/sortimentsmatrix')
        || pathname.includes('/novi/settings')
        || pathname.includes('/sortimentmatrixsettings')
        || pathname.includes('/novi/view')
        || pathname.includes('/wup/view')
        || pathname.includes('/calendar')) {
        const returnUrlPath = `${pathname}${search}`;
        sessionStorage.setItem('returnUrl', returnUrlPath);
        console.log(`Saved returnUrl in sessionStorage: ${returnUrlPath}`);
      }



      environment.connections.TaskListService = configuration["TaskListService"]?.toString();
      environment.connections.CalendarService = configuration["CalendarService"]?.toString();

      environment.connections.SettingService = configuration['SettingService']?.toString();
      environment.connections.AdvWebapi = configuration['AdvWebapi']?.toString();
      environment.connections.CommonWebApi = configuration['CommonWebApi']?.toString();

      environment.connections.DocumentService = configuration['DocumentService']?.toString();
      environment.connections.JWWSService = configuration['JWWSService']?.toString();
      environment.connections.SignalService = configuration['SignalService']?.toString();
      environment.connections.MediatipService = configuration['MediatipService']?.toString();
      environment.connections.UploadService = configuration['UploadService']?.toString();
      environment.connections.UploadStagingService = configuration['UploadStagingService']?.toString();
      environment.connections.ValidationEditService = configuration['ValidationEditService']?.toString();

      environment.connections.KatalogWebapi = configuration['KatalogWebapi']?.toString();

      environment.moebelEditorUrl = configuration['moebelEditorUrl']?.toString();
      environment.SortimentierenPortalUrl = configuration['SortimentierenPortalUrl']?.toString();
      environment.production = environment.production;
      environment.sendInvite = environment.sendInvite;
      environment.inviteDiff = environment.inviteDiff;
      environment.sendInviteOne = environment.sendInviteOne;
      environment.sendInviteTwo= environment.sendInviteTwo;
      environment.sendInviteThree= environment.sendInviteThree;
      environment.inviteOneDiff= environment.inviteOneDiff;
      environment.inviteTwoDiff= environment.inviteTwoDiff;
      environment.inviteThreeDiff= environment.inviteThreeDiff;
      environment.taskTexts= environment.taskTexts;

      environment.protoTyping = configuration['protoTyping'];
      environment.admins = configuration['admins'];
      environment.suppliers = configuration['suppliers'];
      environment.managers = configuration['managers'];
      environment.mandant = configuration['mandant'];
      environment.contacts = configuration['contacts'];
      environment.user = configuration['user'];
      environment.elasticSearchUrl = configuration["ElasticSearchUrl"]?.toString();
      environment.FeatureToggle = configuration['FeatureToggle'] ?? [];

      return environment as ILieferantenPortalEnvironment;
    }  catch (error) {
      console.error(error);

    }
  })().then((e) => {


    environmentService.environment = e;
    environmentService.authConfig = authConfig;
    authService.start();


  });


};
